import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  activate(event) {
    const tabId = event.currentTarget.dataset.tabsId

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tabsId === tabId)
    })
  }
}
